<template>
    <div class="md-layout-item md-size-100">
        <md-card>
            <md-card-header class="md-card-header-icon md-card-header-blue">
                <div class="card-icon">
                    <font-awesome-icon class="md-icon" :icon="['fa', icon]" />
                </div>
                <h4 class="title font-normal">{{ title }}</h4>
            </md-card-header>
            <md-card-content>

                <div v-for="documentType in documents"
                     :key="documentType.id" :id="documentType.id"
                     class="bloc-documents"
                >
                    <h4 class="title-bloc-documents text-primary">{{ documentType.name }}</h4>
                    <div v-if="documentType.documents.length > 0" class="mt-2">
	                    <div v-for="document in documentType.documents" :key="document.id" class="flex items-center mt-1 mb-1.5">
		                    <font-awesome-icon class="md-icon" :icon="['fa', 'file']" />
		                    <a :href="document.url" target="_blank" class="file-name">{{ document.name }}</a>
	                    </div>
                    </div>
	                <span v-else>Aucun document pour cette catégorie</span>
                    <template v-if="documentType.children.length > 0">
                        <div v-for="child in documentType.children" :key="child.id" class="mt-2.5 ml-5">
                            <h3 class="subtitle-bloc-documents text-primary">{{ child.name }}</h3>
                            <div v-if="child.documents.length > 0" class="mt-2">
                                <div class="flex flex-col sub-list">
                                    <div v-for="document in child.documents" :key="document.id" class="flex items-center mb-2">
                                        <font-awesome-icon class="md-icon" :icon="['fa', 'file']" />
                                        <a :href="document.url" target="_blank" class="file-name">{{ document.name }}</a>
                                    </div>
                                </div>
                            </div>
	                        <span v-else>Aucun document pour cette sous-catégorie</span>
                        </div>
                    </template>
                </div>

            </md-card-content>
        </md-card>
    </div>
</template>

<script>
export default {
    name: "GlobalDocumentsCard",
    props: {
        title: String,
        icon: String,
        documents: Array
    },
}
</script>

<style scoped lang="scss">

</style>
